import { Component, OnInit } from '@angular/core';
import { ModalController, ToastController, AlertController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { libraryManagementUserInfo } from '../../modals/libraryManagementdata';
import { BackendCallService } from 'src/app/services/backend-call/backend-call.service';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import * as XLSX from 'xlsx';
import { isNotEmptyArray } from 'src/app/utilities/utils';
import { ShareValuesService } from 'src/app/services/sharedValues/share-values.service';
import { ToastService } from 'src/app/services/toast.service';
import { AppConstants } from 'src/app/utilities/constant';
type AOA = any[][];

@Component({
  selector: 'app-upload-file',
  templateUrl: './upload-file.component.html',
  styleUrls: ['./upload-file.component.scss'],
})
export class UploadFileComponent implements OnInit {
  libraryData = [];
  librarybindData: any;
  isShowButton: any;
  isSubmitDone: any;
  isShowStepper = false;
  isButtonEnable = false;
  isDoneButtonEnable = false;
  isUploadEnable = false;
  Next = false;
  Done = false;
  isShowlabel = false;
  file: any;
  machineName: any;
  machinetype: any;
  manufacturer: any;
  fileSource: any;
  selectedFile: File | null = null;
  fileToUpload: any;

  selectedStepperValue = 'selectType';
  myForm = new UntypedFormGroup({
    file: new UntypedFormControl('', [Validators.required]),
  });
  data: AOA = [[1, 2], [3, 4]];
  wopts: XLSX.WritingOptions = { bookType: 'xlsx', type: 'array' };
  fileName = 'SheetJS.xlsx';


  constructor(
    public modalController: ModalController,
    public backendService: BackendCallService,
    public sharedService: ShareValuesService,
    public toastController: ToastController,
    public alert: AlertController,
    private toastService: ToastService,
    private translate: TranslateService
  ) { }

  ngOnInit() {
    this.libraryData = libraryManagementUserInfo;
  }

  close() {
    const _self = this;
    _self.modalController.dismiss({
      dismissed: true,
    });
  }

  onClickNext() {
    this.isShowStepper = true;
    this.librarybindData = this.libraryData.forEach((element) => {
      this.librarybindData = element.title;
    });
    this.isUploadEnable = true;
    this.Done = true;
  }

  dismissModal() {
    const _self = this;
    _self.modalController.dismiss({
      dismissed: true,
    });
    this.toastService.presentToast(this.translate.instant('file_uploaded_successfully'), 4000, AppConstants.SUCCESS_SNACKBAR, 'top');
  }

  fileUpload(files) {//files: FileList
    this.fileToUpload = files?.target?.files.item(0);
  }

  async submitFile() {
    const formData = new FormData();
    formData.append('file', this.fileSource);
    this.backendService.uploadDocument(formData).subscribe(
      (data: any) => {
        if (data && data.value) {
        } else if (data.statusCode == 201) {
          const noDataFond = data.returnText;
        }
      },err=>{
        this.toastService.presentToast(this.translate.instant('no_results_found'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
      }
    );
  }

  uploadFileToServer() {
    this.backendService.uploadDocument(this.fileToUpload).subscribe(data => {
      // do something, if upload success
    },err=>{
      this.toastService.presentToast(this.translate.instant('no_results_found'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
    });
  }


  changeButtonEvent(event) {
    if (!this.isShowButton) {
      this.isButtonEnable = false;
    }
    else {
      this.isButtonEnable = true;
    };
  }

  onFileChange(event: any) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.myForm.patchValue({
        fileSource: file
      });
    }
  }
  isDoneSubmit(event){
    if (!this.isSubmitDone) {
      this.isDoneButtonEnable = false;
    }
    else {
      this.isDoneButtonEnable = true;
    };
  }
}


